"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "30", height: "30", viewBox: "0 0 30 30", className: "Icon toolbar-transparent-on", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { transform: "translate(1 1)", fill: "none", fillRule: "evenodd" },
            _react2.default.createElement(
                "g",
                { fill: "#D9D9D9" },
                _react2.default.createElement("path", { d: "M.875 1L4 0v4H0zM8 0h4v4H8zM16 0h4v4h-4zM24 0l2.875.937L28 4h-4zM4 4h4v4H4zM12 4h4v4h-4zM20 4h4v4h-4zM0 24h4v4L.875 26.812zM8 24h4v4H8zM16 24h4v4h-4zM24 24h4l-1.063 3.125L24 28zM0 8h4v4H0zM8 8h4v4H8zM16 8h4v4h-4zM24 8h4v4h-4zM4 12h4v4H4zM12 12h4v4h-4zM20 12h4v4h-4zM0 16h4v4H0zM8 16h4v4H8zM16 16h4v4h-4zM24 16h4v4h-4zM4 20h4v4H4zM12 20h4v4h-4zM20 20h4v4h-4z" })
            ),
            _react2.default.createElement("rect", { stroke: "#000", width: "28", height: "28", rx: "2.4", strokeWidth: "2" }),
            _react2.default.createElement("path", { d: "M14 6a3.136 3.136 0 0 1 3.13 3.13c0 .239-.051.486-.13.74.217-.154.435-.274.663-.348a3.133 3.133 0 0 1 3.946 2.011 3.126 3.126 0 0 1-2.011 3.935c-.23.075-.481.105-.75.109.214.16.402.328.543.522a3.131 3.131 0 0 1-.684 4.37c-1.396 1.013-3.367.71-4.38-.685A2.452 2.452 0 0 1 14 19.11a2.452 2.452 0 0 1-.326.674c-1.014 1.395-2.985 1.698-4.38.685a3.131 3.131 0 0 1-.685-4.37c.14-.194.33-.363.543-.522a2.539 2.539 0 0 1-.75-.109 3.126 3.126 0 1 1 1.935-5.946c.228.074.446.194.663.348a2.517 2.517 0 0 1-.13-.74A3.136 3.136 0 0 1 14 6zm0 9.667c.884 0 1.6-.722 1.6-1.611 0-.89-.716-1.612-1.6-1.612-.884 0-1.6.722-1.6 1.612 0 .89.716 1.61 1.6 1.61z", fill: "#4C4C4C", fillRule: "nonzero" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/small/jsx/toolbar-transparent-on.js
// module id = 1895
// module chunks = 0